import { Paper, useTheme } from '@mui/material';
import React, { useState } from 'react';
import ReactApexChart from 'react-apexcharts';

const HistogramChart = ({
  series,
  categories,
  title,
  x_axis_title,
  y_axis_title,
  colors,
  no_data_text,
  on_click_event = () => { },
  // theme
}) => {
  const theme = useTheme();
  const [options_and_series] = useState({
    series: [{ name: "Count", data: [...series] }],
    options: {
      chart: {
        height: 360,
        type: 'bar',
        toolbar: { show: true },
        events: { click: on_click_event },
        zoom: { enabled: true },
      },
      colors: colors || [theme.palette.primary.main],
      plotOptions: {
        bar: {
          columnWidth: '45%',
          distributed: true,
          // borderRadius: 7,
          dataLabels: { position: 'top' },
        },
      },
      dataLabels: { enabled: false },
      legend: { show: false },
      tooltip: {
        enabled: true,
        y: { formatter: value => value.toFixed(0) + ` Sample${value > 1 ? "s" : ""}` },
        style: { fontSize: theme.typography.fontSize + 'px', color: theme.palette.text.secondary },
      },
      yaxis: {
        title: { text: y_axis_title, style: { color: theme.palette.text.secondary } },
        labels: { formatter: value => value.toFixed(0) },
        min: 0,
        // max: 5
      },
      xaxis: {
        categories: categories.map(category => category.split("_").join(" ")),
        labels: { style: { fontSize: theme.typography.fontSize + 'px', color: theme.palette.text.secondary } },
        title: { text: x_axis_title, offsetY: -1 },
      },
      title: {
        text: title || 'Histogram Chart',
        align: 'center',
        style: { color: theme.palette.text.primary, fontSize: '16px', fontWeight: 'semi-bold' },
      },
      noData: { align: "center", verticalAlign: "middle", text: no_data_text || "No Data Found" },
    },
  });
  return (
    <Paper className='p-2 m-2'>
      <ReactApexChart options={options_and_series.options} series={options_and_series.series} type='bar' height="370" />
    </Paper>
  );
};

export default HistogramChart;
